import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { insertTrackableHTML } from 'js/utils/DOM.util';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

const html = (dynamicYieldId, deferAttribute) => {
    const defer = deferAttribute ? 'defer' : '';

    return `<script ${defer} src="//cdn.dynamicyield.com/api/${dynamicYieldId}/api_dynamic.js"></script>\n`
        + `<script ${defer} src="//cdn.dynamicyield.com/api/${dynamicYieldId}/api_static.js"></script>`;
};

export const DynamicYield = ({ config, tagName }) => {
    const { dynamicYieldId, deferAttribute } = config;

    useEffect(() => {
        if (dynamicYieldId === '') {
            return;
        }

        return insertTrackableHTML({ selector: 'head', html: html(dynamicYieldId, deferAttribute),
            tagName, wrapperComment: 'Dynamic Yield'
        });
    }, [deferAttribute, dynamicYieldId, tagName]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.dynamicYield]: DynamicYield });
